import { getRequest, postRequest } from '../../../shared/axiosRequest';
import { API_PATHS } from '../../../shared/apiConsts';
import { dashboardActions } from '../../reducers/dashboard/dashboard';

export const getRecentEPR = () => {
  return async dispatch => {
    try {
      const response = await getRequest(API_PATHS.GET_RECENT_EPR);
      dispatch(dashboardActions.setRecentEPR(response));
    } catch (error) {
      console.error(error);
    }
  };
};

export const getEPRTargets = (project, release) => {
  return async dispatch => {
    try {
      const response = await getRequest(API_PATHS.GET_TARGETS, {
        project,
        release,
      });
      dispatch(dashboardActions.setEPRTargets(response));
    } catch (error) {
      console.error(error);
    }
  };
};

export const getRecentPPR = () => {
  return async dispatch => {
    try {
      const response = await getRequest(API_PATHS.GET_RECENT_PPR);
      dispatch(dashboardActions.setRecentPPR(response));
    } catch (error) {
      console.error(error);
    }
  };
};

export const getNBJobs = userName => {
  return async dispatch => {
    try {
      const response = await getRequest(API_PATHS.GET_NB_JOBS, { userName });
      dispatch(dashboardActions.setNBJobs(response));
    } catch (error) {
      console.error(error);
    }
  };
};

export const runEPR = (ReleasePath, ReleaseSetupCommand, SimregressCommand) => {
  return async dispatch => {
    try {
      const response = await postRequest(API_PATHS.RUN_EPR, {
        ReleasePath,
        ReleaseSetupCommand,
        SimregressCommand,
      });
      dispatch(dashboardActions.setRefreshNBJobs(true));
    } catch (error) {
      console.error(error);
    }
  };
};

export const setRefreshNBJobs = refresh => {
  return async dispatch => {
    dispatch(dashboardActions.setRefreshNBJobs(refresh));
  };
};
